'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMinusWide, iconMinusWideTag } from '@ni/nimble-components/dist/esm/icons/minus-wide';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMinusWide };
export { iconMinusWideTag };
export const NimbleIconMinusWide = wrap(IconMinusWide);